export default __webpack_public_path__ + "static/media/envelope.49402e99.svg";